import { __decorate } from "tslib";
import { FoundationProperty } from '@tyler-components-web/core';
import { CalendarDropdownAdapter } from './calendar-dropdown-adapter';
import { CalendarDropdownFoundation } from './calendar-dropdown-foundation';
var CalendarDropdown = /** @class */ (function () {
    function CalendarDropdown(_targetElement, config) {
        this._targetElement = _targetElement;
        this._foundation = new CalendarDropdownFoundation(new CalendarDropdownAdapter(this._targetElement));
        if (config) {
            Object.assign(this, config);
        }
    }
    CalendarDropdown.prototype.destroy = function () {
        this._foundation.destroy();
    };
    /** Propagates a key event to the underlying calendar. */
    CalendarDropdown.prototype.propagateKey = function (key, isShiftKey) {
        this._foundation.propagateKey(key, isShiftKey);
    };
    /** Sets the highlighted active day on the current month (if the provided date exists on the currently visible month). */
    CalendarDropdown.prototype.setActiveDate = function (date) {
        this._foundation.setActiveDate(date);
    };
    Object.defineProperty(CalendarDropdown.prototype, "value", {
        /** Gets/sets the selected value in calendar. */
        get: function () {
            return this._foundation.value;
        },
        set: function (value) {
            this._foundation.value = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarDropdown.prototype, "min", {
        /** Gets/sets the minimum date that can be selected in the calendar. */
        get: function () {
            return this._foundation.min;
        },
        set: function (value) {
            this._foundation.min = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarDropdown.prototype, "max", {
        /** Gets/sets the maximum date that can be selected in the calendar. */
        get: function () {
            return this._foundation.max;
        },
        set: function (value) {
            this._foundation.max = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarDropdown.prototype, "blockedDates", {
        /** Gets/sets the dates that are restricted from being selected. */
        get: function () {
            return this._foundation.blockedDates;
        },
        set: function (value) {
            this._foundation.blockedDates = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarDropdown.prototype, "open", {
        /** Gets/sets the open state of the dropdown. */
        get: function () {
            return this._foundation.open;
        },
        set: function (value) {
            this._foundation.open = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarDropdown.prototype, "range", {
        /** Gets/sets the range mode. */
        get: function () {
            return this._foundation.range;
        },
        set: function (value) {
            this._foundation.range = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarDropdown.prototype, "id", {
        /** Gets/sets the id that is applied to the popup element. */
        get: function () {
            return this._foundation.id;
        },
        set: function (value) {
            this._foundation.id = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarDropdown.prototype, "popupClasses", {
        /** Gets/sets the CSS classes that are applied to the popup element. */
        get: function () {
            return this._foundation.popupClasses;
        },
        set: function (value) {
            this._foundation.popupClasses = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarDropdown.prototype, "showToday", {
        /** Gets/sets whether the today button is visible in the dropdown. */
        get: function () {
            return this._foundation.showToday;
        },
        set: function (value) {
            this._foundation.showToday = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarDropdown.prototype, "showClear", {
        /** Gets/sets whether the clear button is visible in the dropdown. */
        get: function () {
            return this._foundation.showClear;
        },
        set: function (value) {
            this._foundation.showClear = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarDropdown.prototype, "dialogWidthThreshold", {
        /** Sets the screen width threshold for which a dialog is used to display the calendar instead of the standard popup. */
        set: function (value) {
            this._foundation.dialogWidthThreshold = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarDropdown.prototype, "closeCallback", {
        /** Sets the callback that will be called when the dropdown is closed by the user.  */
        set: function (cb) {
            this._foundation.closeCallback = cb;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarDropdown.prototype, "selectCallback", {
        /** Sets the callback that will be called when selecting a date in the calendar. */
        set: function (cb) {
            this._foundation.selectCallback = cb;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarDropdown.prototype, "activeChangeCallback", {
        /** Sets the callback that will be executed when changing the active element in the calendar. */
        set: function (cb) {
            this._foundation.activeChangeCallback = cb;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarDropdown.prototype, "todayCallback", {
        /** Sets the callback that will be executed when clicking the today button. */
        set: function (cb) {
            this._foundation.todayCallback = cb;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarDropdown.prototype, "clearCallback", {
        /** Sets the callback that will be executed when clicking the clear button. */
        set: function (cb) {
            this._foundation.clearCallback = cb;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        FoundationProperty()
    ], CalendarDropdown.prototype, "disabledDaysOfWeek", void 0);
    __decorate([
        FoundationProperty({ set: true })
    ], CalendarDropdown.prototype, "disableDayCallback", void 0);
    __decorate([
        FoundationProperty()
    ], CalendarDropdown.prototype, "startView", void 0);
    return CalendarDropdown;
}());
export { CalendarDropdown };
